import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { findSection, findActiveTab } from "./navConfig";

// Section tabs bar — renders the active sidebar section's sub-options as tabs.
// Each tab navigates to its existing route (same component opens). Sections
// without tabs (Dashboard, AI, Reports) render nothing.
export default function SubNav() {
  const loc = useLocation();
  const nav = useNavigate();
  const section = findSection(loc.pathname);

  if (!section || section.tabs.length === 0) return null;

  const active = findActiveTab(section, loc.pathname);

  return (
    <nav
      aria-label={`${section.label} tabs`}
      className="flex-shrink-0"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
        padding: "0 24px",
        background: "#FFFFFF",
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        minHeight: 42,
        overflowX: "auto",
      }}
    >
      {section.tabs.map((t) => {
        const isActive = active?.to === t.to;
        return (
          <button
            key={t.to}
            onClick={() => nav(t.to)}
            aria-current={isActive ? "page" : undefined}
            style={{
              position: "relative",
              padding: "11px 12px",
              fontSize: 13,
              fontWeight: isActive ? 600 : 500,
              color: isActive ? section.color : "#64748B",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              whiteSpace: "nowrap",
              fontFamily: "inherit",
              transition: "color 160ms",
            }}
          >
            {t.label}
            {isActive && (
              <span
                style={{
                  position: "absolute",
                  left: 8,
                  right: 8,
                  bottom: 0,
                  height: 2,
                  borderRadius: "2px 2px 0 0",
                  background: section.color,
                }}
              />
            )}
          </button>
        );
      })}
    </nav>
  );
}
